<script lang="ts">
	import { Storyblok } from '#library/storyblok.svelte.ts'

	let { data } = $props()

	const storyblok = $derived(new Storyblok(data.story))
	const story = $derived(storyblok.story)
	const Template = $derived(Storyblok.templates.get(storyblok.story?.content.component || 'page'))
</script>

{#if story}
	{#key story.id}
		<Template data={storyblok} />
	{/key}
{/if}
